<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8niaB8/tc-custom/9781504028172.jpg?1705751376107" alt="This image is the cover for the book Murder Keeps a Secret, The Reuben Frost Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Murder Keeps a Secret, The Reuben Frost Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>When his godson is pushed out of a window, Reuben Frost looks for a killer who’s trying to rewrite history</b><br/>  <br/> Reuben Frost waits patiently for his turn to purchase the tickets that will allow him to get his hands on a weak martini. Though wary of his fellow guests at the annual charity dinner, the brilliant lawyer, recently put out to pasture by his white-shoe firm, will endure his watered-down drink for the sake of his godson. David Rowan is a rising star in the publishing world, and his blockbuster biographies have earned him the $100,000 Reuff Prize for American History and a seat at the head of the banquet. But Rowan is about to learn that when stars stop rising, they come crashing back down to earth.<br/>  <br/> When he falls to his death from his office window, his godfather is convinced that the young man must have been murdered. But who would kill a scholar? With the help of his loyal wife, this septuagenarian sleuth will find that history is a dangerous subject.<br/>  <br/><i>Murder Keeps a Secret</i> is the 4th book in the Reuben Frost Mysteries, but you may enjoy reading the series in any order.<br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Haughton Murphy
      </h2>
      
      <p class="authorDescription body article">Haughton Murphy is the pseudonym of former lawyer James H. Duffy, author of the Reuben Frost Mysteries. A graduate of Princeton University and Harvard Law School, Duffy got his start writing as a part-time and summer reporter for the <I>Daily Times</I> of Watertown, New York, before moving to New York City to practice law. After a number of years as an attorney, Duffy began writing thrillers, eventually retiring to focus on his novels full-time.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42fc4c08